/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ShieldCheck = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" }],
    ["path", { d: "m9 12 2 2 4-4" }]
  ]
];

export { ShieldCheck as default };
//# sourceMappingURL=shield-check.js.map
